import React, { useState, useEffect } from "react";
import RfqService from "../../Services/rfq_service";
import ViewQuotationDetails from "./ViewQuotations_Content";
import { useNavigate } from "react-router-dom";

const QuotationsContent = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <button
        className="text-[#2b6e73] border border-[#2b6e73] rounded-full w-9 h-9 flex items-center justify-center"
        onClick={() => navigate("/customerPortal/MyDashboard")}
      >
        ←
      </button>
      <h2 className="text-2xl font-bold text-[#2b6e73] mb-4">Quotations Received</h2>

      <QuotationsTable />
    </div>
  );
};

export default QuotationsContent;

const DashboardCard = ({ title }) => {
  return (
    <div className="bg-white p-5 rounded-lg shadow-lg flex-1">
      <h2 className="text-3xl font-semibold" style={{ color: "#2b6e73" }}></h2>
      <p className="text-gray-700 font-medium">{title}</p>
      <p className="text-sm text-gray-500"></p>
    </div>
  );
};

const QuotationsTable = () => {
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Add error state
  const [selectedQuotation, setSelectedQuotation] = useState(null);

  useEffect(() => {
    const loadQuotations = async () => {
      try {
        setLoading(true);
        setError(null); // Reset error
        const result = await RfqService.getAllQuotations();
        console.log("Quotations API Response:", result); // Debug log

        if (result.success) {
          // Log raw data to inspect structure
          console.log("Raw Quotations Data:", result.data);
          // Filter based on actual status or adjust if needed
          const filtered = result.data.filter(
            (q) =>
              q.quatation?.status === "QuotationSent" ||
              q.quatation?.status === "Revised"
          );
          console.log("Filtered Quotations:", filtered); // Debug log
          setQuotations(filtered);
        } else {
          setError(result.message || "Failed to fetch quotations");
        }
      } catch (err) {
        console.error("Quotations fetch error:", err.message);
        setError("Something went wrong while fetching quotations");
      } finally {
        setLoading(false); // Ensure loading is set to false
      }
    };

    loadQuotations();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    const d = new Date(dateStr);
    return d.toLocaleDateString();
  };

  const handleView = (quotation) => {
    setSelectedQuotation(quotation);
  };

  const closeView = () => {
    setSelectedQuotation(null);
  };

  if (loading) {
    return <div className="text-center text-gray-600">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600">{error}</div>; // Display error
  }

  if (quotations.length === 0) {
    return <div className="text-center text-gray-600">No quotations available</div>;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg mt-6 overflow-x-auto">
      <div className="bg-white p-4 rounded-lg shadow">
        <h2 className="text-xl font-semibold text-[#2b6e73] mb-4">Quotations Received</h2>
        <table className="min-w-full text-sm text-center border">
          <thead style={{ backgroundColor: "#2b6e73" }}>
            <tr className="text-white">
              <th className="p-3 text-center">ID</th>
              <th className="p-3">RFQ</th>
              <th className="p-3">Date</th>
              <th className="p-3">Client</th>
              <th className="p-3">Assignee</th>
              <th className="p-3">Status</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {quotations.map((quotation, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="p-3 text-center text-gray-800">
                  {quotation.quatation?.orderNo || "NA"}
                </td>
                <td className="p-3 text-center text-gray-800">
                  {quotation.salesEnquiry?.rfqNo || "NA"}
                </td>
                <td className="p-3 text-center text-gray-800">
                  {formatDate(quotation.quatation?.quatationDate)}
                </td>
                <td className="p-3 text-center text-gray-800">
                  {quotation.quatation?.clientName || "NA"}
                </td>
                <td className="p-3 text-center text-gray-800">
                  {quotation.quatation?.assigneeName || "NA"}
                </td>
                <td className="p-3 text-center">
                  <span
                    className="px-3 py-1 rounded-full text-xs font-semibold"
                    style={{ backgroundColor: "#FFF9DB", color: "#2b6e73" }}
                  >
                    {quotation.quatation?.status || "NA"}
                  </span>
                </td>
                <td className="p-2 text-center space-x-2">
                  <button
                    className="text-[#2b6e73] hover:underline text-sm font-semibold"
                    onClick={() => handleView(quotation)}
                  >
                    👁️ View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {selectedQuotation && (
          <div className="mt-4">
            <ViewQuotationDetails quotation={selectedQuotation} closeView={closeView} />
          </div>
        )}
      </div>
    </div>
  );
};